import styled from 'styled-components';

const LandingModalPageSplitter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export default LandingModalPageSplitter;
